import { Navigate, Outlet } from 'react-router-dom'

import { FormWithSimpleMaterializedFormsFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { QuestionnaireType } from 'modules/forms/components/newFormEditor/types'

export type TabsIds = 'questions' | 'responses'

type Props = {
  openSidepanel: boolean
  setOpenSidepanel: (value: boolean) => void
  trainingForm?: FormWithSimpleMaterializedFormsFragment
  trainingId?: number
  questionnaire?: QuestionnaireType
  setQuestionnaire?: (questionnaire: QuestionnaireType | undefined) => void
}

export const Form = ({
  openSidepanel,
  setOpenSidepanel,
  trainingForm,
  trainingId,
  questionnaire,
  setQuestionnaire,
}: Props) => {
  const { navigation } = useNavigation()

  if (!trainingForm) {
    return (
      <Navigate
        to={
          trainingId
            ? navigation.trainings.list.details_revamp.view.surveys.fullPath({
                id: trainingId,
              })
            : navigation.trainings.list.surveyTemplates.list.fullPath()
        }
      />
    )
  } else {
    return (
      <Outlet
        context={{
          trainingForm: trainingForm,
          openSidepanel: openSidepanel,
          setOpenSidepanel: setOpenSidepanel,
          questionnaire: questionnaire,
          setQuestionnaire: setQuestionnaire,
        }}
      />
    )
  }
}
